<div class="technical-error-container" *ngIf="showTechnicalErrorPageFound">
  <img src="assets/mascot/Mascot_sorry-Grey@2x.webp" alt="odaring mascot"/>
  <h1 class="heading-8">{{'technical.error.title.1' | translate}}</h1>
  <button type="button" class="btn-refresh" (click)="reload()">{{'button.refresh' | translate}}</button>
</div>
<app-bottom-odaring-back (onClickNavigation)="onClickNavigation()"></app-bottom-odaring-back>
